import PropTypes from "prop-types";
import { memo } from "react";

const ShowTooltip = ({ epssClassName, value, placement }) => {
  return (
    <span
      className={`Custom_tooltipText tooltip-placement-${placement} ${
        epssClassName || ""
      }`}
    >
      {value}
    </span>
  );
};

ShowTooltip.propTypes = {
  epssClassName: PropTypes.string,
  value: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
};

ShowTooltip.defaultProps = {
  epssClassName: "",
  placement: "top",
};

export default memo(ShowTooltip);
